import { call, put, takeLatest } from 'redux-saga/effects';
import {
  login as loginAction,
  logged,
  logout,
  logouted,
  setIsLoginExpired,
  setUserName,
  checkLoginAction,
} from './actions';
import { success } from '../user-info/actions';
import getAPI from '../../api/iv-back';
import { Constants } from 'core';
import { YieldOf } from 'types/utils';
import { LoginData, LoginResponse } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { sagaWithCallback } from '../utils';

type LoginActionPayload = ReturnType<typeof loginAction>;

export function* bootstrapApp() {
  yield put(clearStateSlice({ sliceReducer: 'ResetPassword' }));
}

export function* cleanBeforeLogout() {
  yield put(clearStateSlice({ sliceReducer: 'UserInfo' }));
}

export function* loginSaga({ meta }: LoginActionPayload) {
  yield put(setUserName(meta.userName));
  const { login } = getAPI();
  const response: YieldOf<typeof login> = yield call(login, meta.userName, meta.password);
  const { data, ok, problem, status } = response;
  if (status === Constants.LOGIN_EXPIRED_STATUS) {
    yield put(setIsLoginExpired(true));
  }
  if (ok) {
    const { expirationDate, ...rest } = data as LoginResponse;
    const loginData: LoginData = {
      expirationDate,
    };
    yield put(logged(loginData));
    yield put(success(rest));
    yield call(bootstrapApp);
  } else {
    const error = problem || 'unknown';
    yield put(logged(undefined, error));
  }
}

export function* checkLoginSaga() {
  const { checkLogin } = getAPI();
  const response: YieldOf<typeof checkLogin> = yield call(checkLogin);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    const { expirationDate, ...rest } = data as LoginResponse;
    const loginData: LoginData = {
      expirationDate,
    };
    yield put(logged(loginData));
    yield put(success(rest));
    yield call(bootstrapApp);
    return data;
  } else {
    const error = problem || 'unknown';
    yield put(logged(undefined, error));
    throw new Error('checkLogin problem ' + error);
  }
}

export function* logoutSaga() {
  const { logout } = getAPI();
  yield call(logout);
  yield call(cleanBeforeLogout);
  yield put(logouted());
}

export default function* authSaga() {
  yield takeLatest(loginAction.type, loginSaga);
  yield takeLatest(checkLoginAction.type, sagaWithCallback(checkLoginSaga));
  yield takeLatest(logout.type, logoutSaga);
}
